import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from '../../hooks/useAuthState';

const InfluencerRoute = ({children}) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const authState = useAuthState();

  if (!token) {
    return <Navigate to="/login" replace state={{from:location}} />;
  }

  if (!authState.role || !authState.role.includes("Influencer")) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default InfluencerRoute;
